<template>
  <div class="online-link-down">
    <a-col v-for="(comp,index) in compList" :key=" 'linkdown'+index " :md="6" :sm="8">
      <mtc-form-item :label="comp.title">
        <j-multi-select-tag v-if="comp.view === 'list_multi'"
                            :ref=" 'onl-comp'+index "
                            @change="v => handleChangeSelect(v,index)"
                            :placeholder="getLinkDownPlaceholder(comp)"
                            :options="comp.options"
                            v-model="queryParam[comp.key]"
                            allowClear>
        </j-multi-select-tag>
        <a-select v-else
                  :ref=" 'onl-comp'+index "
                  @change="v => handleChangeSelect(v,index)"
                  :placeholder="getLinkDownPlaceholder(comp)"
                  show-search
                  :filter-option="filterOption"
                  v-model="queryParam[comp.key]"
                  allowClear>
          <a-select-option v-for="(item, opindex) in comp.options"
                           :key="opindex"
                           :value="item.store">
            <span style="display: inline-block;width: 100%" :title="item.label">
              {{ item.label }}
            </span>
          </a-select-option>
        </a-select>
      </mtc-form-item>
    </a-col>
  </div>
</template>

<script>
import { getAction } from '@/api/manage'

export default {
  name: 'MtcLinkDown',
  components: {},
  props: {
    formitem: {
      type: Object,
      required: false,
      default: () => {
      }
    },
    queryParam: {
      type: Object,
      default: () => {
      },
      required: true
    }
  },
  data() {
    return {
      url: '/online/cgform/api/querySelectOptions',
      compList: []
    }
  },
  created() {
    this.initCompList().then(() => {
      this.queryOptions(1)
    })
    this.$bus.$on('formInitDataSuccess', (row) => {
      this.initSelectPerLevel(row).catch(() => {
      })
    })
  },
  beforeDestroy() {
    this.$bus.$off('formInitDataSuccess')
  },
  methods: {
    filterOption(input, option) {
      return (
        option.componentOptions.children[ 0 ].children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    async initSelectPerLevel(row) {
      const that = this
      await this.queryOptions(1)
      let callbackRow = {}
      for (let i = 0; i < this.compList.length; i++) {
        let field = this.compList[ i ][ 'key' ]
        let store = row[ field ]
        callbackRow[ field ] = store
        if (!store || store.length == 0) {
          continue
        } else {
          await that.initSubSelect(store, i)
        }
      }
    },
    initSubSelect(store, pindex) {
      return new Promise((resolve, reject) => {
        let pid = this.getSelectedIdByStore(store, pindex)
        this.queryOptions(pindex + 2, pid).then(() => {
          resolve()
        }).catch(() => {
          reject()
        })
      })
    },
    getLinkDownFormItem(formitem, comp) {
      let obj = { ...formitem }
      obj.label = comp.title
      return obj
    },
    getLinkDownPlaceholder(comp) {
      return '请选择' + comp.title
    },
    initCompList() {
      return new Promise(resolve => {
        let arr = []
        let index = 1
        arr.push({
          key: this.formitem.field,
          options: [],
          seq: index,
          view: 'list',
          title: this.formitem.label
        })
        let others = this.formitem.others
        if (others && others.length > 0) {
          for (let item of others) {
            index = index + 1
            arr.push({
              key: item.field,
              options: [],
              seq: index,
              view: item.view || 'list',
              title: item.title
            })
          }
        }
        this.compList = [...arr]
        resolve()
      })
    },
    handleChangeSelect(value, index) {
      let pid = this.getSelectedIdByStore(value, index)
      let seq = index + 2
      this.queryOptions(seq, pid)
      this.resetNextLevelField(index)
    },
    resetNextLevelField(index) {
      if (index < 0 || index >= (this.compList.length - 1)) {
        return ''
      }
      let obj = {}
      obj[ this.compList[ index + 1 ].key ] = ''
      this.$emit('changeQuery', obj)
    },
    getSelectedIdByStore(store, index) {
      // 取到的是store的值 但是需要转成id  才能往后台发起请求数据
      let id = ''
      for (let opt of this.compList[ index ].options) {
        if (opt.store == store) {
          id = opt.id
          break
        }
      }
      return id
    },
    queryOptions(seq, pid) {
      return new Promise((resolve, reject) => {
        let params = this.getQueryParam(seq, pid)
        getAction(this.url, params).then(res => {
          if (res.success) {
            for (let comp of this.compList) {
              if (comp.seq === seq) {
                comp.options = res.result || []
              }
            }
            resolve()
          } else {
            reject()
          }
        }).catch(() => {
          reject()
        })
      })
    },
    getQueryParam(seq, pid) {
      let { config } = this.formitem
      let param = {
        table: config.table,
        txt: config.txt,
        key: config.key,
        idField: config.idField,
        pidField: config.pidField
      }
      if (seq == 1) {
        param[ 'condition' ] = config.condition
      } else {
        param[ 'pidValue' ] = pid
      }
      return param
      /*return {
        table:'sys_category',
        txt:'name',
        key:'id',
        idField:'id',
        pidField:'pid',
        linkField:'city',
        condition:" pid = '1230769196661510146' "
      }*/
    }
  }
}
</script>